import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "../css/Settings.module.css";

export default function ChangeMobile() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const [step, setStep] = useState(1);
  const [otp, setOtp] = useState("");
  const [newMobile, setNewMobile] = useState("");
  const [newOtp, setNewOtp] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Simulate API calls below with your actual API
  const sendOtpToCurrent = async () => {
    setLoading(true);
    setError("");
    // await api.sendOtp(user.mobile);
    setLoading(false);
  };

  const verifyCurrentOtp = async () => {
    setLoading(true);
    setError("");
    // const valid = await api.verifyOtp(user.mobile, otp);
    const valid = otp === "1234"; // For demo
    setLoading(false);
    if (valid) {
      setStep(2);
    } else {
      setError(t("ChangeMobile.invalid_otp", "Invalid OTP. Please try again."));
    }
  };

  const sendOtpToNew = async () => {
    setLoading(true);
    setError("");
    // await api.sendOtp(newMobile);
    setLoading(false);
  };

  const verifyNewOtpAndUpdate = async () => {
    setLoading(true);
    setError("");
    // const valid = await api.verifyOtp(newMobile, newOtp);
    const valid = newOtp === "5678"; // For demo
    if (valid) {
      // await api.updateMobile(user.id, newMobile);
      // Update localStorage, etc.
      setLoading(false);
      alert(t("ChangeMobile.success", "Mobile number updated successfully!"));
      navigate("/settings");
    } else {
      setLoading(false);
      setError(t("ChangeMobile.invalid_otp", "Invalid OTP. Please try again."));
    }
  };

  return (
    <div className={styles.pageContainer}>
      <h2>{t("ChangeMobile.title", "Change Mobile Number")}</h2>
      {step === 1 && (
        <>
          <div>
            {t("ChangeMobile.verify_current", "Verify your current mobile number:")} <b>{user.mobile}</b>
          </div>
          <button onClick={sendOtpToCurrent} disabled={loading}>
            {t("ChangeMobile.send_otp", "Send OTP")}
          </button>
          <input
            type="text"
            placeholder={t("ChangeMobile.enter_otp", "Enter OTP")}
            value={otp}
            onChange={e => setOtp(e.target.value)}
            maxLength={6}
          />
          <button onClick={verifyCurrentOtp} disabled={loading}>
            {t("ChangeMobile.verify", "Verify")}
          </button>
        </>
      )}
      {step === 2 && (
        <>
          <div>
            {t("ChangeMobile.enter_new", "Enter your new mobile number")}
          </div>
          <input
            type="text"
            placeholder={t("ChangeMobile.new_mobile", "New Mobile Number")}
            value={newMobile}
            onChange={e => setNewMobile(e.target.value)}
            maxLength={10}
          />
          <button onClick={sendOtpToNew} disabled={loading || !newMobile}>
            {t("ChangeMobile.send_otp", "Send OTP")}
          </button>
          <input
            type="text"
            placeholder={t("ChangeMobile.enter_otp", "Enter OTP")}
            value={newOtp}
            onChange={e => setNewOtp(e.target.value)}
            maxLength={6}
          />
          <button onClick={verifyNewOtpAndUpdate} disabled={loading}>
            {t("ChangeMobile.verify_and_update", "Verify & Update")}
          </button>
        </>
      )}
      {error && <div className={styles.errorMessage}>{error}</div>}
    </div>
  );
}